import React, { useState, useEffect } from 'react';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import './StaticPages.css';

// Get your free access key from https://web3forms.com
const WEB3FORMS_ACCESS_KEY = '13e78312-3083-476f-b4e3-8368b22cabc0';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          name: formData.name,
          email: formData.email,
          message: formData.message,
          subject: `New Contact Form Submission from ${formData.name}`,
          from_name: 'Hobi Contact Form'
        })
      });

      const result = await response.json();

      if (result.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', message: '' });
      } else {
        throw new Error(result.message || 'Something went wrong');
      }
    } catch (err) {
      console.error('Form submission error:', err);
      setError('Failed to send message. Please try again or email us directly.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="static-page-wrapper hero-bg-listing-outdoor" >
      <Navbar dark={true} />
      
      <main className="static-page-content">
        <div className="static-page-container">
          <div className="contact-grid">
            {/* Left Side - Contact Info */}
            <div className="contact-info-side">
              <h2 className="contact-info-heading">Let's Connect</h2>
              <p className="contact-info-text">
                Have questions about events, activities, or just want to say hi? 
                We're here to help you discover amazing experiences.
              </p>

              <div className="contact-details">
                <div className="contact-detail-item">
                  <div className="contact-icon-box">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <div>
                    <span className="contact-label">Email</span>
                    <a href="mailto:info@hobi.co.in" className="contact-value">hi@hobi.co.in</a>
                  </div>
                </div>

                

                <div className="contact-detail-item">
                  <div className="contact-icon-box">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <div>
                    <span className="contact-label">Location</span>
                    <span className="contact-value">Bangalore, Karnataka</span>
                  </div>
                </div>
              </div>

              
            </div>

            {/* Right Side - Form */}
            <div className="contact-form-side">
              {submitted ? (
                <div className="contact-success">
                  <div className="success-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <h3>Message Sent!</h3>
                  <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                  <button className="contact-submit-btn" onClick={() => setSubmitted(false)}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form className="contact-form-new" onSubmit={handleSubmit}>
                  <div className="form-field">
                    <label>Your Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-field">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-field">
                    <label>Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us more..."
                      rows={5}
                      required
                      disabled={loading}
                    />
                  </div>

                  {error && (
                    <div className="contact-error">
                      {error}
                    </div>
                  )}

                  <button type="submit" className="contact-submit-btn" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

